import React, { createContext, useContext, useState } from 'react';

interface SettingsContextType {
  isSettingsSidebarOpen: boolean;
  setIsSettingsSidebarOpen: (open: boolean) => void;
  toggleSettingsSidebar: () => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

/** When true, settings sidebar is inside the app's Sheet on mobile; Sidebar should render content inline instead of its own Sheet. */
export const SettingsSidebarInAppSheetContext = createContext<boolean>(false);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

interface SettingsProviderProps {
  children: React.ReactNode;
}

export const SettingsProvider = ({ children }: SettingsProviderProps) => {
  const [isSettingsSidebarOpen, setIsSettingsSidebarOpen] = useState(false);

  const toggleSettingsSidebar = () => {
    setIsSettingsSidebarOpen(prev => !prev);
  };

  return (
    <SettingsContext.Provider
      value={{
        isSettingsSidebarOpen,
        setIsSettingsSidebarOpen,
        toggleSettingsSidebar,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};